module.exports = __webpack_public_path__ + "img/coupon-icon.6004b494.svg";